<template>
	<AppLayout :title="trans('admin.users.boards.certificates.title')">
		<Empty v-if="boards.length === 0"/>
		<CardGrid v-else>
			<Card v-for="board in boards" :key="`board-${board.id}`" :title="board.years" :subtitle="transChoice('admin.users.boards.areas.count', board.areas_count)">
				<template #badges>
					<Badge v-if="board.active" :color="Color.Green" active>{{ trans('general.enabled') }}</Badge>
					<Badge v-else :color="Color.Red">{{ trans('general.disabled') }}</Badge>
				</template>
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.boards.certificates.show', board.id)">
						<i class="fa-solid fa-eye mr-2"/>
						{{ trans('general.view') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import {ref, type Ref, defineProps} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import {trans, transChoice} from 'laravel-vue-i18n'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import {type Board} from '@/Types/Association/Boards/Board'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'

const props = defineProps<{
	boards:Array<Board>,
}>()

const boards:Ref<Array<Board>> = ref(props.boards)
</script>